import 'element-closest/browser';

import './globals';
import { init } from './core/ready';
import { ready } from './utils/events';

ready(init);
